import './Error404.scss'

export default function Error404() {
  return (
    <div className='error'>
        <div className='wrapper'>
            <span className='code'>404</span>
            <span className='message'>Page not found.</span>
        </div>
    </div>
  )
}
